module.exports = __webpack_public_path__ + "static/media/KarmaIcon.207a843f.png";